// src/services/AuthService.js

import { CognitoIdentityProviderClient, InitiateAuthCommand, ConfirmSignUpCommand } from "@aws-sdk/client-cognito-identity-provider";
import { signInMock } from "./loginService";
import axiosInstance from './ApiService';
import { jwtDecode } from "jwt-decode";

export const cognitoClient = new CognitoIdentityProviderClient({
  region: process.env.REACT_APP_COGNITO_REGION
});


export const signIn = async (username, password) => {
  let AuthenticationResult = {}
  if (process.env.REACT_APP_USE_MOCK_SERVER === 'true') {
    console.log('Using MOCK sign in')
    AuthenticationResult = await signInMock(username, password)
    localStorage.setItem("Username", AuthenticationResult.IdToken || '');

  } else {
    AuthenticationResult = await signInCognito(username, password)
    if (AuthenticationResult.AccessToken) {
      const decodedToken = jwtDecode(AuthenticationResult.AccessToken);
      localStorage.setItem("Username", decodedToken.sub || '');
    }
  }
  localStorage.setItem("IdToken", AuthenticationResult.IdToken || '');
  localStorage.setItem("AccessToken", AuthenticationResult.AccessToken || '');
  localStorage.setItem("RefreshToken", AuthenticationResult.RefreshToken || '');

  return AuthenticationResult
}

export const signInCognito = async (username, password) => {
  const params = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };
  try {
    const command = new InitiateAuthCommand(params);
    const { AuthenticationResult } = await cognitoClient.send(command);
    if (AuthenticationResult) {
      return AuthenticationResult;
    }
  } catch (error) {
    console.error("Error signing in: ", error);
    throw error;
  }
};

export const signUpBackend = async (email, password, givenName, familyName) => {
  const body = {
    password: password,
    email: email,
    firstname: givenName,
    lastname: familyName
  };

  try {
    const response = await axiosInstance.post('/signup', body);
    return {
      success: true,
      message: "Sign up successful. Please check your email to confirm your account.",
      data: response.data
    };
  } catch (error) {
    console.error("Error signing up with backend: ", error);
    throw error;
  }
};

export const confirmSignUp = async (username, code) => {
  const params = {
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    Username: username,
    ConfirmationCode: code,
  };
  try {
    const command = new ConfirmSignUpCommand(params);
    await cognitoClient.send(command);
    return true;
  } catch (error) {
    console.error("Error confirming sign up: ", error);
    throw error;
  }
};